import { useEffect, useState, useMemo } from "react";
import { debounce, set } from "lodash";

import styled from "@emotion/styled";

import { Grid, Checkbox, Button } from "@mui/material";

import { useFormData } from "../../../contexts/FormData";

import { useFormikContext } from "formik";

import { useQuery } from "@tanstack/react-query";

import { searchOpenTickets } from "../apiService";

import { BasicFlex, InputLabel, ScrollableContainer } from "../../../utils/Common";

import MultiStatusChip from "../../../utils/utilities/MultiStatusChip";

import { formatGenericDate } from "../../../utils/util";

const Container = styled.div`
  margin-top: 1rem;
`

const SContainer = styled(ScrollableContainer)`
  width: 90rem;
  margin-bottom: 6rem;

  input {
    cursor: pointer;
  }
`;

const Row = styled(BasicFlex)`
  gap: 1rem;
  /* margin-bottom: 1rem; */
  border-bottom: 1px solid ${props => props.theme.colors.border};
`;

const RowItem = styled.div`
  padding: 1.2rem;
`

const OpenRepairs = () => {
  const { formValues } = useFormData() || {};
  const { values } = useFormikContext() || {};

  const [searchWig, setSearchWig] = useState(values?.wig_id);

  const debouncedWigId = useMemo(
    () => debounce((value) => setSearchWig(value), 500),
    []
  );

  useEffect(() => {
    debouncedWigId(values?.wig_id);
    // Cleanup to prevent memory leaks/unexpected behavior if component unmounts
    return () => debouncedWigId.cancel();
  }, [values?.wig_id, debouncedWigId]);

  const { data: openTickets } = useQuery({
    queryKey: ["repair_tickets", values?.customer_id, searchWig],
    queryFn: () => searchOpenTickets(values?.customer_id, searchWig, values?.repair_ticket_id),
    enabled: !!values?.customer_id
  })

  console.log(openTickets, "openTickets");

  if (!values?.customer_id || !openTickets?.length) return null;

  return (
    <Container>
      <InputLabel>Open Repair Tickets For - {formValues?.customer_name}</InputLabel>
      <SContainer>
        {openTickets?.map(ticket => {
          // const isChecked = selectedIds.has(el.wig_id);
          return (
          <Row key={ticket.repair_ticket_id}>
            <RowItem>
              {/* <input 
                type="checkbox"
                // checked={isChecked} 
                // onChange={() => handleToggle(el)}
              /> */}
              <Checkbox 
                checked={false} 
                size="small" 
              />
              </RowItem>
            <BasicFlex justify="flex-start" gap="5rem">
              <RowItem>#{ticket.repair_ticket_num}</RowItem>
              <RowItem>{ticket.wig_id}</RowItem>
              <RowItem>{ticket.repair_name}</RowItem>
              {/* <RowItem>{ticket.client_name}</RowItem> */}
              <RowItem>{ticket.current_repair_order} / {ticket.number_of_repairs}</RowItem>
              <RowItem>
                <MultiStatusChip value={ticket.status} values={[{value: "scheduled", label: "Scheduled", status: "primary"}, {value: "prepping", label: "In Prep", status: "warning"}, {value: "in_progress", label: "In Progress", status: "warning"}, {value: "completed", status: "success"}]} />
              </RowItem>
              <RowItem>{formatGenericDate(ticket.created_at, 'short')}</RowItem>
            </BasicFlex>
          </Row>
        )})}
      </SContainer>
      <Button variant="contained">Merge</Button>
    </Container>
  )
};

export default OpenRepairs;